import { categoryRepository } from '@/infrastructure/repositories';
import {
  Category,
  CategoriesResponse,
  UpdateCategoryDto,
  HttpError,
} from '@/domain/entities';

export class CategoryService {
  async getCategories(): Promise<Category[]> {
    try {
      const response = await categoryRepository.getAll();
      return response.categories;
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Failed to fetch categories');
    }
  }

  async getCategory(id: number): Promise<Category> {
    try {
      return await categoryRepository.getById(id);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Failed to fetch category');
    }
  }

  async updateCategory(id: number, updates: UpdateCategoryDto): Promise<void> {
    try {
      await categoryRepository.update(id, updates);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Failed to update category');
    }
  }

  async deleteCategory(id: number): Promise<void> {
    try {
      await categoryRepository.delete(id);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Failed to delete category');
    }
  }

  isSystemCategory(id: number): boolean {
    return id === 1 || id === 2 || id === 3;
  }
}

export const categoryService = new CategoryService();

